module.exports = __webpack_public_path__ + "assets/img/Type E (48).147922d9.jpg";